import { render, staticRenderFns } from "./ButtonShow.vue?vue&type=template&id=78879974"
import script from "./ButtonShow.vue?vue&type=script&lang=js"
export * from "./ButtonShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports